
namespace Matrix.Indexation {
    export class CompositeConstituentColumns {
        static columnsKey = 'Indexation.CompositeConstituent';
    }
}